import axios from "axios";
import config from "../config";
const endPoint = "/shipping/service/v1";

class ShippingComplianceService {
	async check(checkoutId) {
		const url = `${endPoint}/compliances/${checkoutId}`;
		const response = await axios.get(url);
		const { data } = response;
		return data;
	}
}

export default new ShippingComplianceService();
